import { ref } from 'vue'

const loadingCount = ref(0)
const isLoading = ref(false)

export const loading = {
  show() {
    loadingCount.value++
    isLoading.value = true
  },
  hide() {
    loadingCount.value--
    if (loadingCount.value <= 0) {
      loadingCount.value = 0
      isLoading.value = false
    }
  },
  get isLoading() {
    return isLoading.value
  },
  get count() {
    return loadingCount.value
  }
}

export function useLoading() {
  return loading
}
